module.exports = __webpack_public_path__ + "55cb8d4e4bcfb36d50b576c17ddc4d8c.svg";